import * as React from 'react';

import Apps16 from './Apps16';

export const apps16 = () => <Apps16 />;

export default {
    title: 'Icon|Line|Apps16',
    component: Apps16,
    parameters: {
        notes: "`import Apps16 from 'box-ui-elements/es/icon/line/Apps16';`",
    },
};
